let loaded = false;

jQuery(document).ready(function ($) {
  // Przekaż tu listę elementów, które mają być animowane
  window.addEventListener("pageshow", function (event) {
    var historyTraversal =
      event.persisted ||
      (typeof window.performance != "undefined" &&
        window.performance.navigation.type === 2);
    if (historyTraversal) {
      // Zamiast przeładowania strony, uruchom animację
      $("body").css("opacity", 0); // Ustaw opacity na 0
      setTimeout(function () {
        $("body").animate({ opacity: 1 }, 250, function () {
          loaded = true;
          triggerAnimations();
        });
      }, 10);
    }
  });

  const elementsToAnimate = [
    $(".navbar-nav li"),
    $(".app p"),
    $(".app h1, .app h2, .app h3, .app h4, .app h5, .app h6"),
    $(".app li"),
    $(".app .icon"),
    $(".app img"),
    $(
      ".app button, .app .btn, .app input, .app select, .app textarea, .app label"
    ),
  ];

  // Połącz w jeden zbiór i dodaj klasę 'animate'
  const $targets = $(elementsToAnimate)
    .map(function () {
      return this.toArray();
    })
    .get();

  $($targets).addClass("animate");

  $(".content img:not(.no-shadow)").each(function () {
    if (!$(this).closest(".no-shadow").length) {
      $(this).addClass("drop-shadow");
    }
  });

  $(".wp-block-columns").addClass("with-animations");

  // Dodaj animacyjne opóźnienia w obrębie .with-animations
  $(".with-animations").each(function () {
    const $animatedChildren = $(this).find(".animate");
    const count = $animatedChildren.length;

    const baseDelay = 0.35;
    const delayStep = count > 10 ? 0.05 : 0.1; // zmniejsz krok jeśli więcej niż 10
    const maxDelay = 1.5;

    $animatedChildren.each(function (index) {
      const delay = Math.min(baseDelay + index * delayStep, maxDelay);
      $(this).css("animation-delay", `${delay}s`);
    });
  });

  // Dodaj domyślny delay do reszty (które nie mają jawnego opóźnienia)
  $(".animate").each(function () {
    const style = $(this).attr("style") || "";
    if (style.indexOf("animation-delay") === -1) {
      $(this).css("animation-delay", "0.35s");
    }
  });

  if (document.readyState === "complete") {
    setTimeout(function () {
      $("body").animate({ opacity: 1 }, 250, function () {
        loaded = true;
        triggerAnimations();
      });
    }, 500);
  } else {
    $(window).on("load", function () {
      setTimeout(function () {
        $("body").animate({ opacity: 1 }, 250, function () {
          loaded = true;
          triggerAnimations();
        });
      }, 500);
    });
  }

  function isInViewport(el) {
    const rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function triggerAnimations() {
    if (!loaded) return;

    // Najpierw obsłuż `with-animations` — grupowo
    $(".with-animations").each(function () {
      if (isInViewport(this)) {
        $(this)
          .find(".animate")
          .each(function () {
            if (!$(this).hasClass("animate_start")) {
              $(this).addClass("animate_start");
            }
          });
      }
    });

    // Następnie dla pozostałych pojedynczych elementów (np. poza `.with-animations`)
    $(".animate").each(function () {
      if (!$(this).hasClass("animate_start") && isInViewport(this)) {
        $(this).addClass("animate_start");
      }
    });
  }

  $(window).on("scroll resize", function () {
    triggerAnimations();
  });

  $("a[href]:not(.chocolat-image)").on("click", function (e) {
    const link = $(this).attr("href");
    const isExternal =
      this.hostname !== window.location.hostname ||
      $(this).attr("target") === "_blank" ||
      link.startsWith("mailto:") ||
      link.startsWith("tel:") ||
      link.startsWith("#");

    if (!isExternal) {
      e.preventDefault();
      $("body").animate({ opacity: 0 }, 250, function () {
        window.location.href = link;
      });
    }
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/animations.js